import { CommonModule } from '@angular/common'
import { Component, output, viewChild } from '@angular/core'
import { BaseModule } from 'shared/base/base.module'
import { HtButtonIntent } from 'shared/base/ht-button/ht-button.component'
import {
  HtModalComponent,
  HtModalOptions,
} from 'shared/base/ht-modal/ht-modal.component'

@Component({
  selector: 'login-ens-modal',
  imports: [CommonModule, BaseModule],
  templateUrl: './login-ens-modal.component.html',
  styleUrl: './login-ens-modal.component.scss',
})
export class LoginEnsModalComponent {
  readonly modal = viewChild<HtModalComponent>('modal')

  closed = output<void>()

  modalOptions: HtModalOptions = {
    title: {
      text: 'Your duties and responsibilities',
    },
    size: 'small',
    rightBtnArray: [
      {
        show: true,
        text: 'Continue',
        intent: HtButtonIntent.PRIMARY,
        click: () => {
          this.onClose()
        },
      },
    ],
  }

  open() {
    this.modal().open()
  }

  onClose() {
    this.modal().close(false)
    this.closed.emit()
  }
}
